import axios from "axios";
import { DemeterService } from "./service";
import { keycloak } from "../../../../lib/keycloak";
import { filter } from "jszip";
import { CertDemeterDataResponseDTO, CertDemeterResponseDTO, createCertDemeterDTO, GetAllCertificatesFiltersDTO, updateCertDemeterDTO } from "./dto";

export class DemeterServiceImpl implements DemeterService {

    public GetAllDemeter(filters: GetAllCertificatesFiltersDTO): Promise<CertDemeterResponseDTO> {
        return axios.get("/api/demeter", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                order: filters.order,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                customerId: filters.customerId,
                idCertificatoDemeter: filters.idCertificatoDemeter
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET", 
            }
        }).then((response) => response.data)
    }

    // CREATE
    public CreateDemeter(data: createCertDemeterDTO): Promise<void> {
        return axios.post("/api/demeter",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public UpdateDemeter(body: updateCertDemeterDTO, id: string): Promise<void> {
        return axios.put("/api/demeter/" + id,
            body,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

}